import api from './api'
import * as Sentry from '@sentry/browser'
import { useCallback, useState } from 'react'

function useContentLog(user: any, activePost: any) {
  const [logId, setLogId] = useState(null)

  const logContent = async () => {
    if (user && user.matricula && activePost) {
      const componenteID = activePost.cod_componente || 0
      const url = `${process.env.REACT_APP_LOGIN_API}/user/EfetuarLog/${user.matricula}/${activePost.id}/${componenteID}`
      try {
        const res = await api.get(url)
        setLogId(res.data)
      } catch (e: any) {
        console.log('erro ao logar', e)
        Sentry.captureException(e, {
          extra: {
            user_matricula: user.matricula,
            content_title: activePost.title,
            error_message: e.message,
            datetime: Date(),
          },
        })
      }
    }
  }

  const updateLog = useCallback(() => {
    if (logId) {
      api
        .get(`${process.env.REACT_APP_LOGIN_API}/user/FinalizarLog/${logId}`)
        .catch((error: any) => console.log('erro na finalização do log', error))
    }
  }, [logId])

  return { logContent, updateLog, logId }
}

export default useContentLog